import { IconButton, Typography } from "@mui/material";
import React from "react";
import {
  DrawerContent,
  DrawerHeader,
  DrawerRoot,
  StyledDrawer,
  StyledH4,
  StyledH6,
} from "./HuQRDisplayStyles";
import InfoIcon from "src/assets/Room/info.svg";
import CloseIcon from "src/assets/Room/close.svg";
import { QRCodeSVG } from "qrcode.react";
import { useCall } from "src/call-sdk/context/CallContext";
import ConvoQRLogo from "src/assets/Room/convo-qr-logo.svg";

interface HuQRDisplayProps {
  open: boolean;
  onClose: () => void;
}

const qrImageConfig = {
  src: ConvoQRLogo,
  height: 25,
  width: 25,
  excavate: true,
};

const HuQRDisplay: React.FC<HuQRDisplayProps> = ({ open, onClose }) => {
  const { requestId } = useCall();

  const HuJoinURL = `${
    process.env.REACT_APP_BASE_URL
  }/hu-qr-verifying/${requestId?.toUpperCase()}`;

  return (
    <StyledDrawer open={open} variant="persistent" anchor="bottom">
      <DrawerRoot>
        <DrawerHeader>
          <img src={InfoIcon} alt="info Icon" />
          <Typography
            aria-label=" Instruction for a hearing person"
            sx={{
              color: "rgba(255, 255, 255, 0.60)",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "24px",
              fontFamily: "Source Sans Pro",
            }}
          >
            Instruction for a hearing person
          </Typography>
          <IconButton
            style={{
              position: "absolute",
              right: "16px",
            }}
            onClick={onClose}
          >
            <img
              src={CloseIcon}
              aria-label="Close Audio Connect Option"
              alt="close Icon"
            />
          </IconButton>
        </DrawerHeader>
        <DrawerContent>
          <StyledH4>Use your phone to speak and listen</StyledH4>
          <div
            aria-label="Audio Connect QR Code"
            style={{
              width: "128px",
              height: "128px",
              border: "5px solid #FFF",
              borderRadius: "4px",
            }}
          >
            <QRCodeSVG
              level="H"
              imageSettings={qrImageConfig}
              value={HuJoinURL}
            />
          </div>
          <StyledH6>Scan to connect to the interpreter’s audio</StyledH6>
        </DrawerContent>
      </DrawerRoot>
    </StyledDrawer>
  );
};

export default HuQRDisplay;
